import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import _styled from '@emotion/styled/base';
import { Box } from '@mui/material';
import isStyledPropsValid from '../utils/isStyledPropsValid.js';
const StyledReactDatePickerWrapper = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "efwacc22"
})(_ref => {
  let {
    theme
  } = _ref;
  return {
    '& .react-datepicker-wrapper': {
      width: '100%'
    },
    // popper
    '& .react-datepicker': {
      border: "1px solid ".concat(theme.customColors.grey[300]),
      padding: '16px 0'
    }
  };
}, "");

// common styles for both calendar and calendar without calendar
const common = theme => ({
  display: 'flex',
  flexDirection: 'row-reverse',
  // popper left side
  '& .react-datepicker__children-container': {
    width: '150px',
    margin: 0,
    padding: '0 16px',
    color: theme.customColors.grey[700],
    fontSize: '14px',
    fontWeight: 400
  },
  // popper right side
  '& .react-datepicker__month-container': {
    position: 'relative',
    padding: '0 16px'
  },
  '& .react-datepicker__header': {
    backgroundColor: theme.customColors.grey[100],
    paddingTop: 0,
    borderBottom: 'none'
  },
  // don't show previous and next months' day
  '& .react-datepicker__day--outside-month': {
    color: 'transparent',
    pointerEvents: 'none'
  },
  '& .react-datepicker__week': {
    width: 'auto'
  },
  '& .react-datepicker__day': {
    fontSize: '15px',
    width: '40px',
    padding: '3px 0',
    margin: '0.166rem 0',
    border: "1px solid transparent",
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.customColors.purple[600]
    }
  },
  '& .react-datepicker__day--in-selecting-range, & .react-datepicker__day--in-range': {
    '&:hover': {
      backgroundColor: theme.customColors.purple[100],
      borderRadius: 0
    }
  },
  // clander header
  '& .calendar-header': {
    paddingBottom: '12px',
    // paddingTop: 0,
    display: 'flex',
    width: '100%',
    gap: '5px',
    justifyContent: 'center',
    '& .month-prev-btn, & .month-next-btn': {
      backgroundColor: 'transparent',
      border: 'none',
      fontSize: '12px'
    },
    '& .select-container': {
      display: 'flex',
      gap: '5px'
    }
  },
  '& .react-datepicker__day-name': {
    color: '#718096',
    fontSize: '15px',
    width: '35px'
  },
  // calendar days
  '& .react-datepicker__day--today': {
    fontWeight: 'unset'
  },
  // preSelected days
  '& .react-datepicker__day--keyboard-selected, & .react-datepicker__day--selected': {
    backgroundColor: 'transparent',
    color: theme.customColors.black

    // '&:before': { left: '0' },
  },
  '& .react-datepicker__day--in-range, & .react-datepicker__day--in-selecting-range': {
    backgroundColor: theme.customColors.purple[100],
    color: theme.customColors.black,
    margin: '0.166rem 0',
    width: '40px',
    borderRadius: '0',
    zIndex: '5'
  },
  '& .react-datepicker__day--range-start, & .react-datepicker__day--range-end, & .react-datepicker__day--selecting-range-end, & .react-datepicker__day--selecting-range-start': {
    color: theme.customColors.grey[100],
    position: 'relative',
    zIndex: '1'
  },
  '& .react-datepicker__day--range-start, & .react-datepicker__day--selecting-range-start': {
    borderTopLeftRadius: '50%',
    borderBottomLeftRadius: '50%',
    width: '40px',
    paddingRight: '3px',
    // avoid hover effect on the end day
    '&:hover': {
      borderTopLeftRadius: '50%',
      borderBottomLeftRadius: '50%'
    }
  },
  '& .react-datepicker__day--range-end, & .react-datepicker__day--selecting-range-end': {
    borderTopRightRadius: '50%',
    borderBottomRightRadius: '50%',
    width: '40px',
    paddingLeft: '3px',
    // avoid hover effect on the end day
    '&:hover': {
      borderTopRightRadius: '50%',
      borderBottomRightRadius: '50%'
    }
  },
  '& .react-datepicker__day--range-start.react-datepicker__day--range-end, & .react-datepicker__day--selecting-range-start.react-datepicker__day--selecting-range-end': {
    backgroundColor: 'transparent',
    paddingLeft: '0'
  },
  '& .react-datepicker__day--range-start::before, & .react-datepicker__day--selecting-range-start::before, & .react-datepicker__day--range-end::before, & .react-datepicker__day--selecting-range-end::before': {
    content: '""',
    backgroundColor: theme.customColors.black,
    width: '35px',
    height: '34px',
    borderRadius: '50%',
    position: 'absolute',
    top: '0',
    zIndex: '-1'
  },
  '& .react-datepicker__day--range-start::before, & .react-datepicker__day--selecting-range-start::before': {
    left: '0'
  },
  '& .react-datepicker__day--range-end::before, & .react-datepicker__day--selecting-range-end::before': {
    right: '0'
  },
  // hover circle → Grey 700
  '& .react-datepicker__day--range-start:hover, & .react-datepicker__day--selecting-range-start:hover, & .react-datepicker__day--range-end:hover, & .react-datepicker__day--selecting-range-end:hover': {
    color: theme.customColors.grey[100],
    '&::before': {
      backgroundColor: theme.customColors.grey[700]
    }
  },
  '& .react-datepicker__day--disabled:hover': {
    backgroundColor: theme.customColors.grey[100],
    color: '#ccc',
    border: 'none'
  }
});
const StyledReactDatePickerCalendarContainerWithoutCalendar = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "efwacc21"
})(_ref2 => {
  let {
    theme
  } = _ref2;
  return _objectSpread2(_objectSpread2({}, common(theme)), {}, {
    '& .react-datepicker__month-container': {
      display: 'none'
    }
  });
}, "");
const StyledReactDatePickerCalendarContainer = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "efwacc20"
})(_ref3 => {
  let {
    theme
  } = _ref3;
  return _objectSpread2(_objectSpread2({}, common(theme)), {}, {
    // popper left side
    '& .react-datepicker__children-container': _objectSpread2(_objectSpread2({}, common(theme)['& .react-datepicker__children-container']), {}, {
      // ensure combined styles are applied
      borderRight: '1px solid #e0e0e0'
    })
  });
}, "");
export { StyledReactDatePickerCalendarContainer, StyledReactDatePickerCalendarContainerWithoutCalendar, StyledReactDatePickerWrapper };